import { Action, createReducer, on } from '@ngrx/store';
import AuthActions from '../actions/auth.actions';
import { produceOn } from '../../immer.helper';

export interface AuthState {
  user: any;
  otpResponse: any;
}

export const initialState: AuthState = {
  user: {},
  otpResponse: null,
};

const authReducer = createReducer(
  initialState,
  produceOn(AuthActions.SetCurrentUser, (draft: any) => {
    draft.user;
  }),
  // on(AuthActions.SetCurrentUser, (state, { user }) => ({ ...state, user })),
  produceOn(AuthActions.detachContext, (draft: any) => {
    draft;
  }),
  // on(AuthActions.detachContext, (state) => state)

  produceOn(AuthActions.SetOtpResponse, (draft: any, { otpResponse }) => {
    draft.otpResponse = otpResponse;
  })
);

export function reducer(state: AuthState | undefined, action: Action) {
  return authReducer(state, action);
}
